import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { FilloutProvider } from './contexts/FilloutContext';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ReserveArchitecture from './pages/ReserveArchitecture';
import AZGReserveDataPage from './pages/AZGReserveDataPage';
import AZSReserveDataPage from './pages/AZSReserveDataPage';
import ReserveRoomPage from './pages/ReserveRoomPage';
import WrittenContent1Page from './pages/WrittenContent1Page';
import LiveReserveReleasePage from './pages/LiveReserveReleasePage';
import CapitalBarriersArticlePage from './pages/CapitalBarriersArticlePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import IntroducerPage from './pages/IntroducerPage';
import CareersPage from './pages/CareersPage';
import AccountManagerPage from './pages/AccountManagerPage';
import AZGLandingPage from './pages/AZGLandingPage';
import LiquidityProvidersPage from './pages/LiquidityProvidersPage';
import MinesPage from './pages/MinesPage';
import BullionProvidersPage from './pages/BullionProvidersPage';
import IndustryProfessionalsPage from './pages/IndustryProfessionalsPage';
import MiningParticipationProgramPage from './pages/MiningParticipationProgramPage';
import CompanyPage from './pages/CompanyPage';

function AppLayout() {
  const location = useLocation();
  const path = location.pathname.toLowerCase();
  const hideChrome = path === '/introducer' || path === '/mining-participation-program';

  return (
    <>
      {!hideChrome && <Navigation />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        {/* Legacy redirects — superseded by ecosystem pages */}
        <Route path="/how-it-works-mines" element={<Navigate to="/mines" replace />} />
        <Route path="/institutional" element={<Navigate to="/reserve-architecture" replace />} />
        <Route path="/reserve-architecture" element={<ReserveArchitecture />} />
        {/* Redirect old reserve-data to AZG */}
        <Route path="/reserve-data" element={<Navigate to="/reserve-data/azg" replace />} />
        <Route path="/reserve-data/azg" element={<AZGReserveDataPage />} />
        <Route path="/reserve-data/azs" element={<AZSReserveDataPage />} />
        <Route path="/reserve-room" element={<ReserveRoomPage />} />
        <Route path="/reserve-room/written/understanding-arizore" element={<WrittenContent1Page />} />
        <Route path="/reserve-room/written/live-reserve" element={<LiveReserveReleasePage />} />
        <Route path="/reserve-room/written/overcoming-capital-access-barriers" element={<CapitalBarriersArticlePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        <Route path="/introducer" element={<IntroducerPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/careers/account-manager" element={<AccountManagerPage />} />
        <Route path="/btx" element={<AZGLandingPage />} />
        <Route path="/liquidity-providers" element={<LiquidityProvidersPage />} />
        <Route path="/mines" element={<MinesPage />} />
        <Route path="/bullion-providers" element={<BullionProvidersPage />} />
        <Route path="/industry-professionals" element={<IndustryProfessionalsPage />} />
        <Route path="/company" element={<CompanyPage />} />
        {/* Unlisted, password-gated stakeholder review page (noindex) */}
        <Route path="/Mining-participation-program" element={<MiningParticipationProgramPage />} />
        {/* Catch-all — removed/unknown routes redirect to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {!hideChrome && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <FilloutProvider>
          <AppLayout />
        </FilloutProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;